import "./style.scss";

import Plus from "assets/img/svg/plus";
import ExpandedHelpdeskIcon from "components/shared/ExpandedHelpdeskIcon";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";

interface IChannelsHeader {
    title: string;
    subtitle: string;
    btnText: string;
    /**
     * Action click button (here : new channel)
     */
    onCreateChannel: VoidFunction;
    /**
     * If user has edit permissions
     */
    hasEditPermission: boolean;
}

const ChannelsHeader = ({ title, subtitle, btnText, onCreateChannel, hasEditPermission }: IChannelsHeader) => {
    const [t] = useTranslation();
    return (
        <div className="channels-header">
            <div className="channels-header-left">
                <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
                    <h1 className="channels-main-title">{title} </h1>
                    <ExpandedHelpdeskIcon
                        text={t("Channels.Helpdesk")}
                        link="https://helpdesk.crealo.app/fr/article/creer-un-canal-de-distribution-10p0rcj/"
                    />
                </div>
                <span className="channels-subtitle">{subtitle}</span>
            </div>
            {hasEditPermission && (
                <div className="channels-header-right">
                    <StyledButton
                        onClick={() => onCreateChannel()}
                        buttonType="primary"
                        className="new-channel-btn"
                        fullWidth
                    >
                        <Plus />
                        {btnText}
                    </StyledButton>
                </div>
            )}
        </div>
    );
};

export default ChannelsHeader;
